import { Libraries } from '@react-google-maps/api';

export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

export const defaultMapCenter = {
  lat: 40.7128,
  lng: -74.0060
};

export const defaultMapZoom = 12;

export const mapOptions = {
  default: {},
  dark: {}
};

export const mapStyles = {
  default: [],
  dark: [
    { elementType: "geometry", stylers: [{ color: "#1e293b" }] }, // Updated to slate-800
    { elementType: "labels.text.stroke", stylers: [{ color: "#1e293b" }] }, // Updated to slate-800
    { elementType: "labels.text.fill", stylers: [{ color: "#94a3b8" }] }, // Updated to slate-400 (consistent with dark theme)
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#3b82f6" }], // Updated to blue-500 (consistent with primary)
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#3b82f6" }], // Updated to blue-500 (consistent with primary)
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#334155" }], // Updated to slate-700
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#10b981" }], // Updated to emerald-500 (consistent with success color)
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#475569" }], // Updated to slate-600
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#334155" }], // Updated to slate-700
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#cbd5e1" }], // Updated to slate-300
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#475569" }], // Updated to slate-600 (removed brown color)
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#334155" }], // Updated to slate-700
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f8fafc" }], // Updated to slate-50 (consistent with foreground)
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#475569" }], // Updated to slate-600
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#3b82f6" }], // Updated to blue-500 (consistent with primary)
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#1e40af" }], // Updated to blue-800 (consistent with theme)
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#94a3b8" }], // Updated to slate-400
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#1e293b" }], // Updated to slate-800
    },
  ],
};

export function getGoogleMapsConfig() {
  return {
    googleMapsApiKey: GOOGLE_MAPS_API_KEY || '',
    libraries: ['places'] as Libraries,
    language: 'en',
    region: 'US'
  };
}